module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"nameTitle":"Auswahl Stromprodukt","gridTitle":"Netzbezug","pvTitle":"PV-Anlage am Standort"}}')
  delete Component.options._Ctor
}
